export const customListNavColors = {
    text: 'rgba(54, 54, 54, 0.60)',
    textDisabled: 'rgba(54, 54, 54, 0.30)',
    active: '#3F6EB7',
    background: '#ECF0F8',
} as const;

export const CUSTOM_LIST_NAV_NAME_CLASS = 'custom-list-nav-name';

export const customListNavNameSx = {
    flex: '1 1 auto',
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
};

/** 9px padding plus the 24px row menu, so section rows match list rows. */
export const CUSTOM_LIST_NAV_ROW_MIN_HEIGHT = '42px';

interface CustomListNavRowState {
    isActive: boolean;
    isDisabled?: boolean;
    hasItemsInOrder?: boolean;
}

export const customListNavNameColor = ({
    isActive,
    isDisabled = false,
}: CustomListNavRowState): string => {
    if (isDisabled) {
        return customListNavColors.textDisabled;
    }

    if (isActive) {
        return customListNavColors.active;
    }

    return customListNavColors.text;
};

export const customListNavRowBackground = ({
    isActive,
    isDisabled = false,
    hasItemsInOrder = false,
}: CustomListNavRowState): string => {
    if (isDisabled) {
        return 'transparent';
    }

    if (isActive || hasItemsInOrder) {
        return customListNavColors.background;
    }

    return 'transparent';
};

export const customListNavRowHoverSx = {
    backgroundColor: customListNavColors.background,
    cursor: 'pointer',
    [`& .${CUSTOM_LIST_NAV_NAME_CLASS}`]: {
        color: customListNavColors.active,
    },
};
